@if (providers().length > 1) {
  <p-select
    data-testid="provider-tenant-switcher"
    [options]="providers()"
    optionLabel="name"
    optionValue="tenantId"
    [ngModel]="selectedTenantId()"
    (onChange)="switchProvider($event.value)"
    [ariaLabel]="'providerManager.switcher.label' | transloco"
    class="min-w-56"
  ></p-select>
}
